import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  useMediaQuery,
  Box,
  ListItemButton,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

import MenuIcon from "@mui/icons-material/Menu";
import { useTheme } from "@mui/material/styles";

const Navbar = () => {
  const theme = useTheme();
  const navigate = useNavigate(); // React Router Navigation Hook

  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  // State for Drawer (Mobile Sidebar)
  const [drawerOpen, setDrawerOpen] = useState(false);

  // Navigation Links
  const menuItems = [{ name: "Home", path: "/" },
    { name: "Dr Tarun Reddy", path: "/about" },
    { name: "Specialties", path: "/specialities" },
    { name: "Cancer Treatments", path: "/treatments" },
    { name: "Blog", path: "/blog" },
    { name: "Media", path: "/media" },
    { name: "Contact Us", path: "/contact" },];

  return (
    <AppBar position="static" sx={{ backgroundColor: "white", boxShadow: "none", borderBottom: "1px solid #ddd" }}>
      <Toolbar sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        {/* Mobile: Hamburger Menu on Left */}
        {isMobile && (
          <IconButton edge="start" color="inherit" onClick={() => setDrawerOpen(true)}>
            <MenuIcon sx={{ color: "#0D1B2A" }} />
          </IconButton>
        )}

        {/* Desktop & Mobile: Centered Navigation */}
        {!isMobile ? (
          <Box sx={{ display: "flex", flexGrow: 1, justifyContent: "center", gap: 3 }}>
            {menuItems.map((item) => (
              <Button key={item}   onClick={() => navigate(item.path)} sx={{ color: "#0D1B2A", fontWeight: "bold", textTransform: "none" }}>
                {item.name}
              </Button>
            ))}
          </Box>
        ) : (
          <Typography variant="h6" sx={{ color: "#0D1B2A", fontWeight: "bold", flexGrow: 1, textAlign: "center" }}>
            Dr. Tarun Reddy
          </Typography>
        )}

        {/* Appointment Button (Separate on the Right) */}
        <Button
          variant="contained"
          sx={{
            borderRadius: 50,
            background: "0D1B2A",
            color: "white",
        
            boxShadow: "0px 5px 10px rgba(0, 0, 255, 0.2)",
            "&:hover": { background: "blue" },
          }}
          
        >
          Appointment
        </Button>

        {/* Mobile: Sidebar Drawer */}
        <Drawer anchor="left" open={drawerOpen} onClose={() => setDrawerOpen(false)}>
          <List sx={{ width: 250 }}>
            {menuItems.map((item) => (
              <ListItemButton key={item} onClick={() => {setDrawerOpen(false); navigate(item.path)}}>
                <ListItemText primary={item.name} />
              </ListItemButton>
            ))}
          </List>
        </Drawer>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
